import styled from 'styled-components';

const ReportNextSteps = styled('ul')`
  li {
    margin-bottom: ${({ theme }) => theme.x2spacePx}px;
    &:last-child {
      margin-bottom: 0;
    }
  }
`;

export { ReportNextSteps as default };
